// extracted by mini-css-extract-plugin
module.exports = {"ExpedientDetailsWrapper":"ExpedientConsultation_ExpedientDetailsWrapper__368cJ","primaryCardWrapper":"ExpedientConsultation_primaryCardWrapper__17DA6"};